import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { of, Subject } from 'rxjs';
import { map, shareReplay, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-internal-information',
  templateUrl: './internal-information.component.html',
  styleUrls: ['./internal-information.component.scss']
})
export class InternalInformationComponent implements OnInit, OnDestroy {
  @Input() inputForm: FormGroup;

  showExternalIdField$ = of(false);
  showExternalCustomerIdField$ = of(false);
  showAssignedTransformerStation$ = of(false);

  private ngUnsubscribe$ = new Subject<void>();

  constructor(private dataShareService: DataShareService) {}

  ngOnInit(): void {
    const config$ = this.dataShareService.tenantConfig$.pipe(
      takeUntil(this.ngUnsubscribe$),
      map((config) => config?.gridRegistration),
      shareReplay(1)
    );
    this.showExternalIdField$ = config$.pipe(map((config) => !!config?.showExternalIdField));
    this.showExternalCustomerIdField$ = config$.pipe(map((config) => !!config?.showExternalCustomerIdField));
    this.showAssignedTransformerStation$ = config$.pipe(
      map((config) => !!config?.showAssignedTransformerStation)
    );
  }

  copyIdFromConnectionObject() {
    this.inputForm
      .get('gridConnectionPointId')
      .patchValue(this.inputForm.get('connectionObject.gisHouseConnectionPoint').value);
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
